import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { F } from "../styl";
import { jeTelefon, jeZPlochy } from "../jeTelefon";

const KLUC = "ps-mobil-neponukat";

// Pruh nad administraciou, ked ju niekto otvori na telefone.
//
// Zamerne to NIE je automaticke presmerovanie: do administracie sa z
// telefonu obcas treba dostat celej, napriklad ked treba nieco, co mobilna
// verzia zamerne nema. Takze ponuka, nie prikaz, a da sa odmietnut natrvalo.
const Pruh = styled.div`
  position: sticky;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: ${F.hlavna};
  color: #fff;
  font-size: 14px;

  .text {
    flex: 1;
    min-width: 0;
    font-weight: 600;
  }

  button {
    flex: 0 0 auto;
    border: none;
    cursor: pointer;
    font-weight: 600;
  }

  .ano {
    height: 36px;
    padding: 0 14px;
    border-radius: 6px;
    background: #fff;
    color: ${F.hlavna};
    font-size: 13px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-weight: 700;
  }

  .nie {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: transparent;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

const PonukaMobilu = () => {
  const history = useHistory();
  const [skryte, setSkryte] = useState(() => {
    try {
      return window.localStorage.getItem(KLUC) === "1";
    } catch (chyba) {
      return false;
    }
  });

  if (skryte || jeZPlochy() || !jeTelefon()) return null;

  return (
    <Pruh>
      <FeatherIcon icon="smartphone" size={19} />
      <span className="text">Máme mobilnú verziu</span>
      <button
        type="button"
        className="ano"
        onClick={() => history.push("/mobil")}
      >
        Otvoriť
      </button>
      <button
        type="button"
        className="nie"
        aria-label="Neponúkať"
        onClick={() => {
          try {
            window.localStorage.setItem(KLUC, "1");
          } catch (chyba) {
            // Sukromne okno. Ponuka sa objavi nabuduce znova, nic viac.
          }
          setSkryte(true);
        }}
      >
        <FeatherIcon icon="x" size={18} />
      </button>
    </Pruh>
  );
};

export default PonukaMobilu;
